import { VehicleOutput } from '@allocab/allocab-commons-shared-types';
import { DriverVehicleOptionsInput } from '@allocab/allocab-driver-service-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient, queryErrorHandler } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

type Input = DriverVehicleOptionsInput & {
  id: string;
};

const patchVehicleOptions = ({ id, ...input }: Input) =>
  driverApi.patch<DriverVehicleOptionsInput, VehicleOutput>(`/v1/vehicle/${id}/options`, input);

export const usePatchVehicleOptions = () =>
  useMutation<VehicleOutput, unknown, Input, { previousVehicle: VehicleOutput | undefined; id: string }>({
    mutationFn: patchVehicleOptions,
    onMutate: async input => {
      const { id, ...newData } = input;
      const queryKey = queryKeys.user.fetchVehicle(id);

      await queryClient.cancelQueries(queryKey);

      const previousVehicle = queryClient.getQueryData<VehicleOutput>(queryKey);

      queryClient.setQueryData(queryKey, {
        ...previousVehicle,
        options: newData.options,
        airportBadgeValidUntil: newData.airportBadgeValidUntil,
      });

      return { previousVehicle, id };
    },
    onError: (error, _input, context) => {
      queryClient.setQueryData(queryKeys.user.fetchVehicle(context?.id), context?.previousVehicle);
      queryErrorHandler(error);
    },
    onSettled: (_, __, { id }) => {
      queryClient.invalidateQueries(queryKeys.user.fetchVehicle(id));
    },
  });
